import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { element } from 'protractor';
import { overduePaymentAlert } from 'src/app/_core/_function/overduePaymentAlert';
import { DataService } from 'src/app/_services/data.service';

@Component({
  selector: 'app-project-status',
  templateUrl: './project-status.component.html',
  styleUrls: ['./project-status.component.scss']
})
export class ProjectStatusComponent implements OnInit {
  message: any = "";
  compId: string;
  projUid: string;
  proj: any;
  floors: any[] = [];
  directions: any[] = [];
  buildList: any[] = [];
  flatsCounter: number = 0;
  prototypes: any[] = [];
  prototypesCollection: any[] = [];
  allUsers: any[] = [];
  galleries: any[] = [];
  isOpenAbout: boolean = false;
  chekList = {
    compLogo: false,
    projLogo: false,
    projMarker: false,
    compMarker: false,
    projGal: false,
    aboutGal: false,
    plan: false,
    overdue: false,
    buildings: false
  }
  buildingModule: boolean = false;
  classAlert: string = '';
  supportPayment: boolean = false;

  constructor(
    public dataService: DataService,
    private route: ActivatedRoute,
  ) {
    this.compId = this.route.snapshot.params.id;
    this.projUid = this.route.snapshot.params.idp;
  }


  ngOnInit(): void {
    window.addEventListener("message", this.receiveMessage.bind(this), false);
    this.dataService.getSpecProject(this.projUid).subscribe(proj => {
      this.getAllUsers();
      if (proj.length > 0) {
        this.proj = proj[0];
        this.proj.modules.forEach(module => {
          if(module.moduleName === 'buildings'){
            this.buildingModule = true;
          }
        })
        // if(this.proj.date){
        //   const currentDate: Date = new Date();
        //   currentDate;
        //   if(this.proj.date < currentDate) {
        //     this.chekList.overdue = true;
        //   }
        // }
        let overduePayment = overduePaymentAlert(proj[0]);
        if(overduePayment){
          this.classAlert = overduePayment.classAlert;
          this.supportPayment = overduePayment.supportPayment;
        }

        // this.illustrationOnly = proj[0].illustrationOnly;
        // this.titleService.setTitle(this.compTitle + '-' + this.proj[0].companyTitle + ' - ' + this.proj[0].title);

        if (this.proj.public === false) {
          console.log("PROJECT NOT PUBLISH");
        }
        this.dataService.getFlatPrototypesByProjId(this.proj.id).subscribe(prototypes => {
          this.prototypesCollection = prototypes;
        });

        this.dataService.getItemsByProjId(this.proj.id).subscribe(buildList => {
          // this.buildList = buildList;
          console.log("==========================================================================", buildList);
          if (this.buildList.length === 0) {
            if(this.buildingModule === true){
              this.chekList.buildings = true;
            }
            console.log("this.buildList", this.buildList)
            buildList.forEach(building => {
              let buildingFlats = [];
              let flatsCounter = 0;
              this.prototypes = [];
              building.floors.forEach(floor => {
                flatsCounter += floor.floor.flats.length;
                floor.floor.flats.forEach(flat => {
                  this.prototypesCollection.forEach(proto => {
                    if (flat.faltPrototype === proto.uid) {
                      flat.faltPrototypeId = proto.id;
                    }
                  })

                })
                buildingFlats.push(floor.floor.flats)
              })
              building.prototypes = this.addFlatsToProtoName(buildingFlats);
              building.flatAmount = flatsCounter;
              // this.prototypes = this.addFlatsToProtoName(buildingFlats);
              this.buildList.push(building);
            })
          }
        })

      }
    });
    this.dataService.getPagesWithLink(this.projUid).subscribe(items => {
      this.galleries = items;
    });

  }

  openItemList(item: any) {
    // Toggle the 'isItemListOpen' property to show/hide the item list
    item.isItemListOpen = !item.isItemListOpen;
  }

  getAllUsers() {
    this.dataService.getUsersByCompId(this.compId).subscribe(element => {
      this.allUsers = element;
    });
  }

  isNoItems($event, type) {
    let isNoItems = !$event;
    switch (type) {
      case 'comp-logo':
        this.chekList.compLogo = isNoItems;
        break;
      case 'proj-logo':
        this.chekList.projLogo = isNoItems;
        break;
      case 'proj-marker':
        this.chekList.projMarker = isNoItems;
        break;
      case 'comp-marker':
        this.chekList.compMarker = isNoItems;
        break;
      case 'plan':
        this.chekList.plan = isNoItems;
        break;
      case 'proj-gal':
        this.chekList.projGal = isNoItems;
        break;
      case 'about-gal':
        this.chekList.aboutGal = isNoItems;
        break;
    }
  }


  addFlatsToProtoName(flats) {
    let flatsArray: any[] = [];
    flats.forEach(element => {
      element.forEach(innerElement => {
        flatsArray.push(innerElement);
      });
    });
    const protoNameWithFlatName = flatsArray.reduce((acc, flat) => {
      if (!acc[flat.prototypeName]) {
        acc[flat.prototypeName] = [];
      }
      acc[flat.prototypeName].push(flat);
      return acc;
    }, {});

    const prototypesWithFlatNumbersArray = Object.keys(protoNameWithFlatName).map(area => ({

      title: area,
      // color: area,
      list: protoNameWithFlatName[area]
    }))

    // this.prototypes = prototypesWithFlatNumbersArray;
    return prototypesWithFlatNumbersArray;

  }


  receiveMessage(event) {
    if (this.proj) {
      setTimeout(() => {
        console.log("Delayed for 1 second.");

        if (event.origin !== 'https://topeye.club/spherikal') {
          this.message = event.data;
          if (typeof (this.message) === 'object') {
            console.log(this.message);
            //   this.sceneTitleArray = this.message;
            this.floors = [];
            this.directions = [];
            this.message.forEach(element => {
              const inputString = element;
              const parts = inputString.split(/\D+/); // \D matches non-digits
              const number = parts.filter(part => part !== "").map(Number);
              if (number.length > 0) {
                this.floors.push(number);
              } else {
                this.directions.push(element);
              }
              console.log(number); // Output: [42, 123.45]
            });

          }
        }
      }, 1000);
    }

  }

}
